import { render } from "./InstantLayoutAnimation.vue?vue&type=template&id=5e011319"
import script from "./InstantLayoutAnimation.vue?vue&type=script&lang=js"
export * from "./InstantLayoutAnimation.vue?vue&type=script&lang=js"

import "./InstantLayoutAnimation.vue?vue&type=style&index=0&id=5e011319&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__